import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Popup } from "semantic-ui-react";
import parser from "ua-parser-js";
export function UserAgent({ value, plain }) {
    const ua = useMemo(() => parser(value), [value]);
    return ((value &&
        (plain ? (`${ua.browser.name} ${ua.browser.major}, ${ua.os.name || ""} ${ua.os.version || ""}, ${ua.device.model || ""} ${ua.device.type || ""}`) : (_jsx(Popup, { content: `${ua.browser.name} ${ua.browser.major}, ${ua.os.name || ""} ${ua.os.version || ""} ${ua.cpu.architecture || ""}, ${ua.device.model || ""} ${ua.device.type || ""}`, trigger: _jsxs("div", { children: [ua.browser.name, ", ", ua.os.name || "", ", ", ua.device.model || "", " ", ua.device.type || ""] }) })))) ||
        "");
}
